module.exports = __webpack_public_path__ + "media/images/flags/32/NATO-c81cb9c18e918e971e29f34b7083e1f0.png";